import _ from 'lodash';
import Items from '../api/items';
import TemplateHelper from '../modules/template-helper';
const templateHelper = new TemplateHelper();

class ItemsSearch {
  /**
   * @param {Object} [options] - Configuration overrides
   * @param {Number} [options.throttleTime] - Request throttle duration in ms
   * @param {Number} [options.termMinLength] - Don't send requests if search term is shorter than this
   * @param {String} [options.selectorForm] - A CSS selector for the search form element
   * @param {String} [options.selectorInput] - A CSS selector for the text input
   * @param {String} [options.selectorOutput] - A CSS selector for the element to contain search results
   * @param {String} [options.templateResults] - The ID of the search results mustache template element
   * @param {Function} [options.searchMethod] - The search method to use for retrieving search results
   */
  constructor(options = {}) {
    const defaults = {
      throttleTime: 500,
      termMinLength: 3,
      selectorForm: 'form[data-action="items-search"]',
      selectorInput: '#itemSearchInput',
      selectorClear: '#itemSearchClear',
      selectorOutput: '#itemSearchOutput',
      templateResults: 'itemsSearchResults',
      searchMethod: Items.search.bind(Items)
    };

    Object.assign(this, defaults, options);
  }

  /**
   * Selects elements and attaches event listeners
   */
  init() {
    this.form = document.querySelector(this.selectorForm);
    if(!this.form) { return; } // exit early if form not found

    this.input = document.querySelector(this.selectorInput);
    this.clear = document.querySelector(this.selectorClear);
    this.output = document.querySelector(this.selectorOutput);

    this.inputHandler = _.throttle(this.handleInput.bind(this), this.throttleTime);
    this.input.addEventListener('input', this.inputHandler);
    if (this.clear) {
      this.clear.addEventListener('click', () => {
        // Input still has old value at this point, let's clear it.
        this.input.value = '';
        this.inputHandler();
      });
    }
  }

  /**
   * Performs a search API request, and populates the results, if applicable.
   */
  handleInput() {
    const term = this.input.value;
    if(term.length < this.termMinLength) {
      this.updateResults({ results: [] });
      return;
    }
    this.searchMethod({ term }).then(res => {
      const { status, results } = res;
      if(status === 'OK' && Array.isArray(results)) {
        this.updateResults({
          results: results,
          noResults: !results.length
        });
      } else {
        this.updateResults({ results: [] });
      }
    });
  }

  /**
   * Renders the template into the output element.
   * @param {Object} view - The template view object
   */
  updateResults(view = {}) {
    templateHelper.render(
      this.templateResults,
      view,
      this.output,
      'replace'
    );
  }
}

export default ItemsSearch;
